import { sellerConstants } from '../../_constants/seller.constants';
import swal from 'sweetalert2/dist/sweetalert2.min.js';

const initialState = {
	loading: true,
	response: '',
	responseCode: '',
	error: false,
	errorText: ''
};

export function addSeller(state = initialState, action) {
	switch (action.type) {
		case sellerConstants.ADD_SELLER_REQUEST:
			return {
				loading: true,
				response: '',
				error: false,
				errorText: '',
				responseCode: ''
			};
		case sellerConstants.ADD_SELLER_SUCCESS:
		swal({
			text: 'Seller Added Successfully',
			type: 'success',
			confirmButtonColor: '#3085d6',
			confirmButtonText: 'OK'
		})
			return {
				loading: false,
				response: action.sellers.statusText,
				error: false,
				errorText: '',
				responseCode: action.sellers.status	
			};
			case sellerConstants.ADD_SELLER_ERROR:
			if (action.error.response.status === 400) {
			  let stringError = ``
			  Object.keys(action.error.response.data).forEach(val => {
				stringError = `${stringError} ${action.error.response.data[val]}`					
			  });
			  swal("", stringError, "warning");
			}
			return {
			  loading: false,
			  response: '',
			  error: true,
			  errorText: action.error,
			  responseCode: ''
			};

		case sellerConstants.REQUEST_UPDATE_SELLER:
			return {
				loading: true,
				response: '',
				error: false,
				errorText: '',
				responseCode: ''
			};
		case sellerConstants.UPDATE_SELLER_SUCCESS:
			return {
				loading: false,
				response: action.data.statusText,
				error: false,
				errorText: '',
				responseCode: action.data.status
			};
		case sellerConstants.UPDATE_SELLER_ERROR:
			if (action.error.response.status === 400) {
				swal("", "Please fill out all required fields", "warning");
			}
			return {
				loading: false,
				response: '',
				error: true,
				errorText: action.error,
				responseCode: ''
			};
		case sellerConstants.REQUEST_ADD_SELLER_ADMIN:
			return {
				loading: true,
				response: '',
				error: false,
				errorText: '',
				responseCode: ''
			};
		case sellerConstants.ADD_SELLER_ADMIN_SUCCESS:
			return {
				loading: false,
				response: action.data.statusText,
				error: false,
				errorText: '',
				responseCode: action.data.status
			};
		case sellerConstants.ADD_SELLER_ADMIN_ERROR:
			if (action.error.response.status === 400) {
				swal("", action.error.response.data.message !== undefined ? action.error.response.data.message : 'Something went wrong, Could not add Seller', "error");
			}
			return {
				loading: false,
				response: '',
				error: true,
				errorText: action.error,
				responseCode: ''
			};
		default:
			return state
	}
}


// WEBPACK FOOTER //
// ./src/_reducers/sellers/addSeller.reducer.js